(() => {
  // Clear the retired complimentary socks offer before checkout.
  const settings = document.getElementById('OsvayneShoeGiftSettings');
  if (!settings || !window.fetch) return;
  const route = window.Shopify?.routes?.root || '/';
  let syncing;
  const sync = () => syncing || (syncing = (async () => {
    const response = await fetch(route + 'cart.js', {cache:'no-store',headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error(settings.dataset.error);
    const cart = await response.json();
    // Remove discontinued gift instructions from old carts, preserving other properties.
    for (const item of cart.items) {
      const properties = {...item.properties};
      if (!properties['Included gift'] && !properties['Welcome gift']) continue;
      properties['Included gift'] = '';
      properties['Welcome gift'] = '';
      const updated = await fetch(route + 'cart/change.js', {
        method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({id:item.key,quantity:item.quantity,properties})
      });
      if (!updated.ok) throw new Error(settings.dataset.error);
    }
    const attributes = {};
    for (const [key,value] of Object.entries(cart.attributes || {})) {
      if (key === 'OSVAYNE welcome' || (key === 'Welcome gift' && /socks/i.test(String(value)))) attributes[key] = '';
    }
    if (Object.keys(attributes).length) {
      const updated = await fetch(route + 'cart/update.js', {
        method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({attributes})
      });
      if (!updated.ok) throw new Error(settings.dataset.error);
    }
  })().finally(() => {syncing = undefined;}));
  document.addEventListener('submit', async event => {
    const button = event.submitter;
    const form = event.target;
    if (button?.name !== 'checkout' || form.dataset.shoeGiftReady === 'true') return;
    event.preventDefault();
    if (form.dataset.shoeGiftBusy === 'true') return;
    form.dataset.shoeGiftBusy = 'true'; button.disabled = true;
    let error = form.querySelector('[data-shoe-gift-error]');
    if (error) error.remove();
    try {
      await sync();
      form.dataset.shoeGiftReady = 'true'; button.disabled = false;
      form.requestSubmit(button);
    } catch (failure) {
      error = document.createElement('p'); error.dataset.shoeGiftError = '';
      error.setAttribute('role','alert'); error.textContent = settings.dataset.error;
      form.append(error); button.disabled = false;
    } finally {form.dataset.shoeGiftBusy = 'false';}
  });
})();

